import {LOG_LEVELS} from 'src/logger';

import type {LogLevels, LogMode, Logger} from 'src/logger';

export const logStyle: Record<LogMode, string> = {
  INFO: 'background: #3880ff; color: #ffffff; border-radius: 3px; padding: 0 5px',
  SUCCESS:
    'background: #10dc60; color: #ffffff; border-radius: 3px; padding: 0 5px',
  WARNING:
    'background: #ffce00; color: #ffffff; border-radius: 3px; padding: 0 5px',
  DANGER:
    'background: #f04141; color: #ffffff; border-radius: 3px; padding: 0 5px',
  DEBUG:
    'background: #666666; color: #ffffff; border-radius: 3px; padding: 0 5px',
};

export const log = (
  mode: LogMode,
  logLevel: LogLevels,
  ...msgs: unknown[]
): void => {
  if (logLevel < LOG_LEVELS[mode]) {
    return;
  }
  // eslint-disable-next-line no-console
  console.log(`%c${mode}`, logStyle[mode], ...msgs);
};

/**
 * Creates a console logger with an optional prefix and log level.
 * @param prefix Prefix to prepend to each log message.
 * @param logLevel Minimum log level to output.
 */
export const createConsoleLogger = (
  prefix = '',
  logLevel: LogLevels = LOG_LEVELS.INFO,
): Logger => {
  return {
    log(msg: string, ...rest: unknown[]): void {
      log('INFO', logLevel, `${prefix}:`, msg, ...rest);
    },
    debug(msg, ...rest): void {
      log('DEBUG', logLevel, `${prefix}:`, msg, ...rest);
    },
    warn(msg, ...rest): void {
      log('WARNING', logLevel, `${prefix}:`, msg, ...rest);
    },
    error(msg, ...rest): void {
      log('DANGER', logLevel, `${prefix}:`, msg, ...rest);
    },
  };
};
